import wwfThemeConfig from "~/static/themes/wwf/config";
import getThemeFromUrl from "~/utils/getThemeFromUrl";
import jigsawThemeConfig from "~/static/themes/jigsaw-research/config";
import appThemeConfig from "~/static/themes/app/config";
import demoThemeConfig from "~/static/themes/demo/config";
import rysenseThemeConfig from "~/static/themes/rysense/config";
import natwestThemeConfig from "~/static/themes/natwest/config";
import sageThemeConfig from "~/static/themes/sage/config";
import sageEarthThemeConfig from "~/static/themes/sage-earth/config";
import sgnThemeConfig from "~/static/themes/sgn/config";
import intuitThemeConfig from "~/static/themes/intuit/config";
import ordnanceThemeConfig from "~/static/themes/ordnance-survey/config";

const themes = [
    {
        name: "wwf",
        config: wwfThemeConfig
    },
    {
        name: "app",
        config: appThemeConfig
    },
    {
        name: "demo",
        config: demoThemeConfig
    },
    {
        name: "jigsaw-research",
        config: jigsawThemeConfig
    },
    {
        name: "rysense",
        config: rysenseThemeConfig
    },
    {
        name: "natwest",
        config: natwestThemeConfig
    },
    {
        name: "sage",
        config: sageThemeConfig
    },
    {
        name: "sage-earth",
        config: sageEarthThemeConfig
    },
    {
        name: "sgn",
        config: sgnThemeConfig
    },
    {
        name: "intuit",
        config: intuitThemeConfig
    },
    {
        name: "ordnance-survey",
        config: ordnanceThemeConfig
    },
];

const getThemeConfig = () => {
    const themeClass = getThemeFromUrl();
    return themes.find(theme => theme.name === themeClass);
};

export default getThemeConfig;
